<template>
  <jd-dialog
    class="selectGoodsMonitor"
    title="活动列表"
    append-to-body
    width="1000px"
    :visible="isShow"
    @close="popupClose"
    :isShowSure="false"
    :isShowCancel="false"
  >
    <div class="activity-selection">
      <div class="selection-tabs">
        <jd-subTab
          style="margin-bottom: 16px"
          :options="tabSwitchListData"
          @input="handleTab"
          :value="currIndex"
        >
        </jd-subTab>
      </div>
    </div>

    <div style="margin-bottom: 15px">
      <jd-Form
        :form-info="inputData"
        ref="inputForm2"
        @search="searchActivity"
        :btnPosition2="true"
      >
      </jd-Form>
    </div>

    <div class="goodsContent">
      <!-- 活动列表 -->
      <div class="activity-table">
        <div class="table-box new-table-box">
          <jd-table
            :tableData="activityList"
            :tableInfo="tableInfo"
            :loading="tableLoading"
            :pageSizes="[5, 10, 30, 50, 100]"
            :pageInfo="{
              pageNum: pageInfo.current,
              pageSize: pageInfo.size,
              total: pageInfo.total,
            }"
            @handlePage="handlePages"
          >
            <template slot-scope="scope" slot="activityType">
              {{ scope.row.subTypeStr }}
            </template>
            <template slot-scope="scope" slot="activityTime">
              {{ scope.row.startTime }}-
              {{ scope.row.endTime }}
            </template>
            <template slot-scope="scope" slot="activityStatus">
              {{ scope.row.statusStr }}
            </template>
            <!-- 投放渠道显示 -->
            <template slot-scope="scope" slot="channelName">
              {{ scope.row.sellerLinkName }}
            </template>
            <template slot-scope="scope" slot="operation">
              <jd-button type="blueText" @click="selectActivity(scope.row)"
                >选择</jd-button
              >
            </template>
          </jd-table>
        </div>
      </div>
    </div>
  </jd-dialog>
</template>

<script>
import { aggregateLinkPage,biShopGiftTypes } from "@/api/jhk/creatLinks";
export default {
  name: "ActivityList",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    activityIds: {
      type: Number,
      default: () => [],
    },
  },
  data() {
    return {
      inputData: [
        {
          label: "活动名称：",
          prop: "activityName",
          type: "Input",
          placeholder: "请输入活动名称",
        },
        {
          label: "活动类型：",
          prop: "subType",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "全部",
            },
          ],
        },
        {
          label: "活动状态：",
          prop: "status",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "未开始", value: "1" },
            { label: "进行中", value: "2" },
            { label: "已结束", value: "3" },
          ],
        },
      ],
      currIndex: 1,
      tabSwitchListData: [
        { value: 1, label: "按活动选择" },
        { value: 2, label: "按投放渠道选择" },
      ],
      pageInfo: {
        total: 0,
        current: 1,
        size: 10,
      },
      searchForm: {
        activityName: "",
        activityType: "",
        activityStatus: "",
      },
      tableInfo: [
        {
          label: "活动名称",
          prop: "activityName",
        },
        {
          label: "活动类型",
          prop: "activityType",
          slot: "activityType",
        },
        {
          label: "活动时间",
          prop: "activityTime",
          slot: "activityTime",
        },
        {
          label: "投放渠道",
          prop: "channelName",
          slot: "channelName",
          // 默认隐藏，在按投放渠道选择时显示
          notShow: true,
        },
        {
          label: "活动状态",
          prop: "activityStatus",
          slot: "activityStatus",
        },
        // 操作
        {
          label: "操作",
          prop: "operation",
          slot: "operation",
        },
      ],
      activityList: [], // 活动列表数据
      tableLoading: false,
      activityTypeList: [] // 保存从接口获取的活动类型数据
    };
  },
  watch: {
    isShow(newVal) {
      if (newVal) {
        // 当弹窗显示时，根据activityIds设置活动类型选项
        this.setActivityTypeOptions();
        this.searchActivity();
      }
    },
    // 监听activityIds变化，更新活动类型选项
    activityIds: {
      handler() {
        this.setActivityTypeOptions();
      },
      immediate: true
    }
  },
  methods: {
    // 设置活动类型选项
    setActivityTypeOptions() {
      // 重置为默认包含"全部"选项
      this.inputData[1].options = [{ value: "", label: "全部" }];
      
      if (this.activityIds == 63) {
        // 当activityIds为63时，从接口获取活动类型
        biShopGiftTypes().then((res) => {
          if (res && res.data && Array.isArray(res.data)) {
            // 将接口返回的数据转换为选项格式，使用name字段作为label
            const typeOptions = res.data.map(item => ({
              value: item.activityType, // 假设接口返回的数据中有id或value作为值
              label: item.name // 使用name字段作为显示标签
            }));
            // 合并到现有选项中
            this.inputData[1].options = this.inputData[1].options.concat(typeOptions);
          }
        }).catch(() => {
          // 如果接口调用失败，使用默认选项
          this.setDefaultActivityTypes();
        });
      } else {
        // 其他情况使用默认选项
        this.setDefaultActivityTypes();
      }
    },
    
    // 设置默认活动类型选项
    setDefaultActivityTypes() {
      this.inputData[1].options = [
        { value: "", label: "全部" },
        { value: 16, label: "下单有礼" },
        { value: 17, label: "首单专享礼" },
        { value: 18, label: "复购有礼" },
        { value: 36, label: "打榜有礼" },
        { value: 46, label: "满额有礼" },
        { value: 67, label: "销售打榜" },
        { value: 68, label: "会员成长计划" },
        { value: 53, label: "购物打卡" },
        { value: 69, label: "拼团砍价" },
      ];
    },
    // 分页查询事件
    handlePages(page) {
      this.pageInfo.current = page.pageNum;
      this.pageInfo.size = page.pageSize;
      this.getActivityList();
    },
    // 切换tab
    handleTab(i) {
      this.currIndex = i;
      this.activityList = [];
      this.pageInfo = {
        total: 0,
        current: 1,
        size: 10,
      };
      if (i == 2) {
        // 当切换到按投放渠道选择时，显示投放渠道列
        this.tableInfo.forEach((col, index) => {
          if (col.prop === "channelName") {
            col.notShow = false;
          }
        });
      } else {
        // 当切换到按活动选择时，隐藏投放渠道列
        this.tableInfo.forEach((col, index) => {
          if (col.prop === "channelName") {
            col.notShow = true;
          }
        });
      }
      // 刷新数据
      this.searchActivity();
    },

    //关闭弹窗
    popupClose() {
      this.$emit("close", false);
    },

    // 搜索活动
    searchActivity(val) {
      this.pageInfo = {
        total: 0,
        current: 1,
        size: 10,
      };
      // 保存查询参数
      if (val && typeof val === "object") {
        this.searchForm.activityName = val.activityName || "";
        this.searchForm.activityType = val.subType || "";
        this.searchForm.activityStatus = val.status || "";
      }

      // 调用API获取活动列表
      this.getActivityList();
    },

    // 获取活动列表
    getActivityList() {
      this.tableLoading = true;
      
      // 构建查询参数，包括查询条件和分页信息
      const queryParams = {
        ...this.recordData,
        createByMe: this.createByMe,
        // 查询条件
        activityName: this.searchForm.activityName,
        subType: this.searchForm.activityType,
        status: this.searchForm.activityStatus,
        // 分页参数
        current: this.pageInfo.current,
        size: this.pageInfo.size,
        selectionType: this.currIndex,
      };
      
      // 获取活动列表的统一处理函数
      const fetchActivityList = () => {
        aggregateLinkPage(queryParams)
          .then((res) => {
            this.tableLoading = false;
            this.activityList = res.data.records;
            // 设置表格总数量
            this.pageInfo.total = Number(res.data.total);
            this.totalNum = Number(res.data.total);
          })
          .catch(() => {
            this.tableLoading = false;
          });
      };
      
      // 根据不同的活动ID设置不同的subTypes参数
      if (this.activityIds === 63) {
        // 当活动ID为63时，从接口获取subTypes
        biShopGiftTypes()
          .then((res) => {
            if (res && res.data && Array.isArray(res.data)) {
              // 从接口返回的数据中获取activityType值并设置到queryParams中
              queryParams.subTypes = res.data.map(item => item.activityType || item.id || item.value);
              // 保存接口返回的完整数据，包含activityType和name等信息
              this.activityTypeList = res.data;
            }
            // 获取活动列表
            fetchActivityList();
          })
          .catch(() => {
            this.tableLoading = false;
          });
      } else {
        // 其他情况使用默认的subTypes值
        queryParams.subTypes = [16, 17, 18, 36, 46,67,68,53,69];
        fetchActivityList();
      }

    },

    // 处理分页大小变化
    handleSizeChange(val) {
      this.pageInfo.size = val;
      this.getActivityList();
    },

    // 处理页码变化
    handleCurrentChange(val) {
      this.pageInfo.current = val;
      this.getActivityList();
    },
    selectActivity(row) {
      this.$emit("selectActivity", row);
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-selection {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  span {
    margin-right: 10px;
    font-weight: 500;
  }
}

.goodsContent {
  .activity-table {
    width: 100%;

    .table-box {
      border: 1px solid #e4e7ed;
      border-radius: 4px;
    }
  }
}

.selectGoodsMonitor {
  .el-dialog__body {
    padding: 20px;
  }
}
</style>
